import PintInput from './PinInput';

export default PintInput;
